import React from 'react'
import { Award, Target, TrendingUp, Users } from 'lucide-react'

const About = () => {
  const milestones = [
    {
      icon: Award,
      title: '5x State Champion',
      description: 'Competitive gymnastics career building discipline and determination'
    },
    {
      icon: TrendingUp,
      title: '#1 Nationally Ranked',
      description: 'Led sales teams to record-breaking performance at AutoMart.com'
    },
    {
      icon: Users,
      title: 'Publish-Speak-Prosper',
      description: 'Founded proven system helping entrepreneurs build authority'
    },
    {
      icon: Award,
      title: '6x Bestselling Author',
      description: 'Award-winning books including "Death of a Yellow Page Salesman"'
    }
  ]

  return (
    <div className="min-h-screen bg-white" data-component-path="client/src/pages/About.jsx" data-component-line="1:1" data-component-id="client/src/pages/About.jsx:1:1">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-20" data-component-path="client/src/pages/About.jsx" data-component-line="2:2" data-component-id="client/src/pages/About.jsx:2:2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="3:3" data-component-id="client/src/pages/About.jsx:3:3">
          <div className="max-w-3xl" data-component-path="client/src/pages/About.jsx" data-component-line="4:4" data-component-id="client/src/pages/About.jsx:4:4">
            <h1 className="font-display font-black text-5xl md:text-6xl mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="5:5" data-component-id="client/src/pages/About.jsx:5:5">
              From Lost to Found — Filled to Overflowing
            </h1>
            <p className="text-xl text-blue-100 leading-relaxed" data-component-path="client/src/pages/About.jsx" data-component-line="6:6" data-component-id="client/src/pages/About.jsx:6:6">
              The journey of Paul T. Neustrom: From competitive athlete to sales champion, through industry disruption to becoming a 6x bestselling author and business transformation coach.
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20" data-component-path="client/src/pages/About.jsx" data-component-line="7:7" data-component-id="client/src/pages/About.jsx:7:7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="8:8" data-component-id="client/src/pages/About.jsx:8:8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-component-path="client/src/pages/About.jsx" data-component-line="9:9" data-component-id="client/src/pages/About.jsx:9:9">
            <div data-component-path="client/src/pages/About.jsx" data-component-line="10:10" data-component-id="client/src/pages/About.jsx:10:10">
              <img
                src="https://www.buzzsprout.com/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTA4NjcwMDE1LCJwdXIiOiJibG9iX2lkIn19--1fc9afcd675c094954d09c62a4347596a7984d49/eyJfcmFpbHMiOnsiZGF0YSI6eyJmb3JtYXQiOiJqcGciLCJyZXNpemVfdG9fbGltaXQiOlsxMDgwLDE0NDAseyJjcm9wIjoiY2VudHJlIn1dLCJzYXZlciI6eyJxdWFsaXR5Ijo2MH0sImNvbG91cnNwYWNlIjoic3JnYiJ9LCJwdXIiOiJ2YXJpYXRpb24ifX0=--355526e0ad8d751b2d7838e573060e1c9e6162cc/Paul%20on%20Stage-%20Headshot.png"
                alt="Paul T. Neustrom speaking on stage"
                className="rounded-2xl shadow-2xl w-full"
                loading="lazy"
                onError={(e) => {
                  e.target.src = 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1200'
                }}
                data-component-path="client/src/pages/About.jsx"
                data-component-line="11:11"
                data-component-id="client/src/pages/About.jsx:11:11"
              />
            </div>
            <div data-component-path="client/src/pages/About.jsx" data-component-line="12:12" data-component-id="client/src/pages/About.jsx:12:12">
              <h2 className="font-display font-black text-4xl text-gray-900 mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="13:13" data-component-id="client/src/pages/About.jsx:13:13">
                The Story Behind the System
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed" data-component-path="client/src/pages/About.jsx" data-component-line="14:14" data-component-id="client/src/pages/About.jsx:14:14">
                <p data-component-path="client/src/pages/About.jsx" data-component-line="15:15" data-component-id="client/src/pages/About.jsx:15:15">
                  Paul T. Neustrom's journey began in competitive gymnastics, where he became a five-time state champion and competed on the #1 ranked collegiate team at the University of Nebraska. The discipline, determination, and competitive drive he developed there would shape his entire career.
                </p>
                <p data-component-path="client/src/pages/About.jsx" data-component-line="16:16" data-component-id="client/src/pages/About.jsx:16:16">
                  Transitioning to sales, Paul became the #1 rep in the nation for AutoMart.com and led multiple sales teams to record-breaking, nationally ranked performance. His ability to inspire and lead teams became legendary in the industry.
                </p>
                <p data-component-path="client/src/pages/About.jsx" data-component-line="17:17" data-component-id="client/src/pages/About.jsx:17:17">
                  But when Google disrupted the Yellow Pages industry, Paul faced his greatest challenge. Rather than accept defeat, he transformed this setback into an opportunity—creating the Publish-Speak-Prosper system to help professionals like himself turn expertise into authority and build thriving businesses.
                </p>
                <p data-component-path="client/src/pages/About.jsx" data-component-line="18:18" data-component-id="client/src/pages/About.jsx:18:18">
                  Today, as a 6x award-winning bestselling author and host of the "Skyrocket to Success" podcast, Paul helps entrepreneurs and professionals—especially those 50+ affected by technology disruption—discover the power of their voice and build lasting authority through publishing and speaking.
                </p>
              </div>
            </div>
          </div>

          {/* Milestones */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-component-path="client/src/pages/About.jsx" data-component-line="19:19" data-component-id="client/src/pages/About.jsx:19:19">
            {milestones.map((milestone, index) => {
              const Icon = milestone.icon
              return (
                <div
                  key={index}
                  className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow duration-300"
                  data-component-path="client/src/pages/About.jsx"
                  data-component-line="20:20"
                  data-component-id="client/src/pages/About.jsx:20:20"
                >
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="21:21" data-component-id="client/src/pages/About.jsx:21:21">
                    <Icon className="w-8 h-8 text-blue-600 flex-shrink-0" data-component-path="client/src/pages/About.jsx" data-component-line="22:22" data-component-id="client/src/pages/About.jsx:22:22" />
                  </div>
                  <h3 className="font-display font-bold text-xl text-gray-900 mb-2" data-component-path="client/src/pages/About.jsx" data-component-line="23:23" data-component-id="client/src/pages/About.jsx:23:23">
                    {milestone.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-component-path="client/src/pages/About.jsx" data-component-line="24:24" data-component-id="client/src/pages/About.jsx:24:24">
                    {milestone.description}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="bg-blue-50 py-20" data-component-path="client/src/pages/About.jsx" data-component-line="25:25" data-component-id="client/src/pages/About.jsx:25:25">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="client/src/pages/About.jsx" data-component-line="26:26" data-component-id="client/src/pages/About.jsx:26:26">
          <h2 className="font-display font-black text-4xl md:text-5xl text-gray-900 mb-6" data-component-path="client/src/pages/About.jsx" data-component-line="27:27" data-component-id="client/src/pages/About.jsx:27:27">
            The Mission
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-8" data-component-path="client/src/pages/About.jsx" data-component-line="28:28" data-component-id="client/src/pages/About.jsx:28:28">
            "People love stories, so share your wonderful breakthroughs from struggle to success!"
          </p>
          <p className="text-lg text-gray-600 leading-relaxed" data-component-path="client/src/pages/About.jsx" data-component-line="29:29" data-component-id="client/src/pages/About.jsx:29:29">
            Paul's mission is to help professionals discover the power of their voice through writing, speaking, and building authority. Whether you're facing career disruption, seeking to level up your business, or ready to share your expertise with the world, the Publish-Speak-Prosper system provides the proven framework to transform your knowledge into lasting impact and overflowing abundance.
          </p>
        </div>
      </section>

      {/* Programs Section */}
      <section className="py-20" data-component-path="client/src/pages/About.jsx" data-component-line="30:30" data-component-id="client/src/pages/About.jsx:30:30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/pages/About.jsx" data-component-line="31:31" data-component-id="client/src/pages/About.jsx:31:31">
          <div className="text-center mb-12" data-component-path="client/src/pages/About.jsx" data-component-line="32:32" data-component-id="client/src/pages/About.jsx:32:32">
            <h2 className="font-display font-black text-4xl md:text-5xl text-gray-900 mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="33:33" data-component-id="client/src/pages/About.jsx:33:33">
              Work With Paul
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-component-path="client/src/pages/About.jsx" data-component-line="34:34" data-component-id="client/src/pages/About.jsx:34:34">
              Transform your expertise into authority through proven programs designed for entrepreneurs and professionals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-component-path="client/src/pages/About.jsx" data-component-line="35:35" data-component-id="client/src/pages/About.jsx:35:35">
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-blue-600 transition-colors duration-300" data-component-path="client/src/pages/About.jsx" data-component-line="36:36" data-component-id="client/src/pages/About.jsx:36:36">
              <h3 className="font-display font-bold text-2xl text-gray-900 mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="37:37" data-component-id="client/src/pages/About.jsx:37:37">
                Publish-Speak-Prosper System
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" data-component-path="client/src/pages/About.jsx" data-component-line="38:38" data-component-id="client/src/pages/About.jsx:38:38">
                Comprehensive coaching and resources to help you become a bestselling author, master speaker, and build a thriving authority-based business.
              </p>
              <a
                href="https://publishspeakprosper.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 font-semibold hover:text-blue-700 inline-flex items-center gap-2"
                data-component-path="client/src/pages/About.jsx"
                data-component-line="39:39"
                data-component-id="client/src/pages/About.jsx:39:39"
              >
                Learn More →
              </a>
            </div>

            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-blue-600 transition-colors duration-300" data-component-path="client/src/pages/About.jsx" data-component-line="40:40" data-component-id="client/src/pages/About.jsx:40:40">
              <h3 className="font-display font-bold text-2xl text-gray-900 mb-4" data-component-path="client/src/pages/About.jsx" data-component-line="41:41" data-component-id="client/src/pages/About.jsx:41:41">
                Co-Author Anthology Program
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" data-component-path="client/src/pages/About.jsx" data-component-line="42:42" data-component-id="client/src/pages/About.jsx:42:42">
                Join our "Guaranteed Bestseller" co-author projects and become a published author alongside other industry leaders and experts.
              </p>
              <a
                href="https://authoritylaunch.com/home-1152-3419"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 font-semibold hover:text-blue-700 inline-flex items-center gap-2"
                data-component-path="client/src/pages/About.jsx"
                data-component-line="43:43"
                data-component-id="client/src/pages/About.jsx:43:43"
              >
                Apply Now →
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About